<template>
  <div id="app" style="overflow: hidden">
    <router-view/>
    <imgPreview></imgPreview>
  </div>
</template>

<script>
  import imgPreview from "@/components/new/common/imgPreview";
  export default {
    name: 'App',
    components: {
      imgPreview,
    },
  }
</script>

<style>
  #app{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue